import * as Sentry from "@sentry/react";
import { Outlet } from "react-router-dom";
import { Layout } from "./layout";
import { ErrorFallbackPage } from "./pages/error-fallback.page";

function App() {
	return (
		<Sentry.ErrorBoundary
			fallback={({ error, componentStack, resetError }) => (
				<ErrorFallbackPage
					error={error as Error}
					componentStack={componentStack}
					resetError={resetError}
				/>
			)}
			showDialog
		>
			<Layout>
				<Outlet />
			</Layout>
		</Sentry.ErrorBoundary>
	);
}

export default App;
